/* ============================================================
   DOGS SUPREME · <ds-futter-rechner>
   Gekapseltes Custom Element: BARF-Futtermengen-Rechner.
   Look: Apple, hell (Storefront ist Hell-only), Design-Fundament
   assets/ds-nav-foundation.css (Spec docs/standards/navigator-design-spec.md).

   Fachbasis (Manufaktur-Futterfibel, nur ERWACHSENE gesunde Hunde):
     · normal          -> 2,0 % vom Koerpergewicht pro Tag
     · etwas mollig    -> 1,8 %
     · zu duenn        -> 4,0 %
   Welpe/Senior bekommen bewusst KEIN Rechenergebnis, nur einen
   Hinweis (Regel deckt sie nicht ab). Ergebnis = Startwert, keine
   tieraerztliche Empfehlung.

   Segment-Reihenfolgen als Skala mit Default in der Mitte
   (identisch ds-nav-check): Welpe|Erwachsen|Senior,
   Zu duenn|Normal|Etwas mollig.

   Bridge (genau EINE): BARF Kennenlern-Box, data-event nach Vertrag
   ai_bridge_click_futtermenge_rechner_kennenlern-box + utm_source=ai-bridge.

   Attribute (optional):
     box-url   Default /products/barf-kennenlern-box
     box-grams Default 2000 (5 Sorten a 400 g)
     box-name  Default BARF Kennenlern-Box

   Laeuft auch AUSSERHALB der Navigator-Sections (BARF-Guide):
   main-article-apple.liquid laedt Foundation+Script konditional,
   ensureFoundation() ist der Fallback.
   Kompatibilitaet wie ds-audio.js: ES2015-class, keine #-Felder,
   kein Optional-Chaining, var + function, reduced-motion beachtet.
   ============================================================ */
(function () {
  'use strict';

  var FACTORS = { normal: 0.02, mollig: 0.018, duenn: 0.04 };

  function round5(n) { return Math.round(n / 5) * 5; }

  /* Pure Rechenlogik (Node-testbar). kg > 0, zustand aus FACTORS. */
  function computeRation(kg, zustand) {
    var f = FACTORS[zustand];
    if (!f || typeof kg !== 'number' || !isFinite(kg) || kg <= 0) return null;
    var perDay = round5(kg * 1000 * f);
    return {
      gramsPerDay: perDay,
      gramsPerMeal: round5(perDay / 2),
      factor: f
    };
  }

  /* Wie viele Tage deckt die Box? null, wenn Angabe unserioes wirkt. */
  function boxDays(boxGrams, gramsPerDay) {
    if (!(boxGrams > 0) || !(gramsPerDay > 0)) return null;
    var d = Math.round(boxGrams / gramsPerDay);
    if (d < 2 || d > 60) return null;
    return d;
  }

  /* Node-Testhook: im Browser inert. */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { computeRation: computeRation, boxDays: boxDays, FACTORS: FACTORS };
    return;
  }

  if (!('customElements' in window) || customElements.get('ds-futter-rechner')) return;

  function ensureFoundation() {
    if (document.getElementById('dsn-foundation')) return;
    var probe = document.querySelector('link[href*="ds-nav-foundation"]');
    if (probe) { probe.id = probe.id || 'dsn-foundation'; return; }
    var self = document.querySelector('script[src*="ds-futter-rechner"]');
    if (!self) return;
    var link = document.createElement('link');
    link.id = 'dsn-foundation';
    link.rel = 'stylesheet';
    link.href = self.src.split('?')[0].replace(/ds-futter-rechner\.js$/, 'ds-nav-foundation.css');
    document.head.appendChild(link);
  }

  function injectStyles() {
    if (document.getElementById('ds-futter-rechner-styles')) return;
    var style = document.createElement('style');
    style.id = 'ds-futter-rechner-styles';
    style.textContent = [
      "ds-futter-rechner .dsfr-group{margin-bottom:16px}",
      "ds-futter-rechner .dsfr-result{display:none;margin-top:20px}",
      "ds-futter-rechner .dsfr-result.dsfr-show{display:block}",
      "ds-futter-rechner .dsfr-amount{font-size:34px;font-weight:700;color:#1d1d1f;letter-spacing:-.02em;line-height:1.21;margin:0 0 4px;font-variant-numeric:tabular-nums}",
      "ds-futter-rechner .dsfr-meals{font-size:15px;color:#1d1d1f;margin:0 0 10px;font-variant-numeric:tabular-nums}",
      "ds-futter-rechner .dsfr-calc{font-size:13px;color:#6e6e73;margin:0 0 2px;font-variant-numeric:tabular-nums}",
      "ds-futter-rechner .dsfr-reset{display:none;margin-top:14px}",
      "ds-futter-rechner .dsfr-reset.dsfr-show{display:inline-flex}",
      "@media (max-width:480px){ds-futter-rechner .dsfr-amount{font-size:29px}",
      "ds-futter-rechner .dsfr-reset.dsfr-show{display:flex;width:100%}}"
    ].join('');
    document.head.appendChild(style);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  var ARROW_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="12" x2="19" y2="12"></line><polyline points="13 6 19 12 13 18"></polyline></svg>';

  function segRow(options, initial, onChange) {
    var wrap = el('div', 'dsn-seg-track');
    wrap.setAttribute('role', 'group');
    var current = initial;
    options.forEach(function (opt) {
      var btn = el('button', 'dsn-seg', opt.label);
      btn.type = 'button';
      btn.setAttribute('data-value', opt.value);
      btn.setAttribute('aria-pressed', opt.value === initial ? 'true' : 'false');
      btn.addEventListener('click', function () {
        if (current === opt.value) return;
        current = opt.value;
        var all = wrap.querySelectorAll('.dsn-seg');
        for (var i = 0; i < all.length; i++) {
          all[i].setAttribute('aria-pressed', all[i].getAttribute('data-value') === current ? 'true' : 'false');
        }
        onChange(current);
      });
      wrap.appendChild(btn);
    });
    return wrap;
  }

  var HINT_WELPE = 'Welpen und Junghunde wachsen: ihre Ration richtet sich nach Alter, Rasse und ' +
    'Entwicklung und ändert sich laufend. Die Faustregel für erwachsene Hunde gilt für sie nicht, ' +
    'deshalb zeigen wir hier bewusst keinen Automatik-Wert an. Lass dir den Futterplan von deiner ' +
    'Tierarztpraxis oder einer qualifizierten Ernährungsberatung erstellen.';
  var HINT_SENIOR = 'Bei älteren Hunden hängt die passende Menge stark von Aktivität, Muskulatur und ' +
    'Gesundheit ab, eine pauschale Formel wird dem nicht gerecht. Sprich die Ration mit deiner ' +
    'Tierarztpraxis ab und kontrolliere das Gewicht regelmäßig.';
  var NOTE_STANDARD = 'Startwert für gesunde, erwachsene Hunde, keine tierärztliche Empfehlung. ' +
    'Beobachte Gewicht und Figur deines Hundes und passe die Menge in kleinen Schritten an. ' +
    'Krank, trächtig oder im intensiven Training? Dann hol dir tierärztlichen Rat.';

  class DsFutterRechner extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      ensureFoundation();
      injectStyles();

      this.boxUrl = this.getAttribute('box-url') || '/products/barf-kennenlern-box';
      this.boxGrams = parseInt(this.getAttribute('box-grams') || '2000', 10);
      this.boxName = this.getAttribute('box-name') || 'BARF Kennenlern-Box';
      this.alter = 'erwachsen';
      this.zustand = 'normal';

      this.render();
    }

    render() {
      var self = this;
      var card = el('div', 'dsn-card');

      card.appendChild(el('p', 'dsn-title', 'Wie viel BARF braucht dein Hund?'));
      card.appendChild(el('p', 'dsn-sub',
        'Faustregel der Manufaktur: rund 2 % des Körpergewichts pro Tag, bei erwachsenen, gesunden Hunden.'));

      var gWeight = el('div', 'dsfr-group');
      var weightLabel = el('label', 'dsn-label', 'Gewicht deines Hundes in kg');
      weightLabel.setAttribute('for', 'DsfrWeight');
      gWeight.appendChild(weightLabel);
      var field = el('div', 'dsn-field dsn-field--suffix');
      var input = el('input', 'dsn-input');
      input.id = 'DsfrWeight';
      input.type = 'number';
      input.step = '0.1';
      input.min = '0.5';
      input.max = '100';
      input.placeholder = 'z. B. 20';
      input.setAttribute('inputmode', 'decimal');
      field.appendChild(input);
      var suffix = el('span', 'dsn-suffix', 'kg');
      suffix.setAttribute('aria-hidden', 'true');
      field.appendChild(suffix);
      gWeight.appendChild(field);
      var errLine = el('p', 'dsn-error-line', 'Bitte ein Gewicht zwischen 0,5 und 100 kg eintragen.');
      errLine.style.display = 'none';
      gWeight.appendChild(errLine);
      card.appendChild(gWeight);
      this.input = input;
      this.errLine = errLine;

      var gAlter = el('div', 'dsfr-group');
      gAlter.appendChild(el('span', 'dsn-label', 'Alter'));
      gAlter.appendChild(segRow(
        [{ value: 'welpe', label: 'Welpe' },
         { value: 'erwachsen', label: 'Erwachsen' },
         { value: 'senior', label: 'Senior' }],
        this.alter,
        function (v) { self.alter = v; self.hideResult(); }
      ));
      card.appendChild(gAlter);

      var gFigur = el('div', 'dsfr-group');
      gFigur.appendChild(el('span', 'dsn-label', 'Figur'));
      gFigur.appendChild(segRow(
        [{ value: 'duenn', label: 'Zu dünn' },
         { value: 'normal', label: 'Normal' },
         { value: 'mollig', label: 'Etwas mollig' }],
        this.zustand,
        function (v) { self.zustand = v; self.hideResult(); }
      ));
      card.appendChild(gFigur);

      var btn = el('button', 'dsn-btn', 'Menge berechnen');
      btn.type = 'button';
      btn.style.width = '100%';
      card.appendChild(btn);

      var result = el('div', 'dsfr-result');
      result.setAttribute('aria-live', 'polite');
      card.appendChild(result);
      this.result = result;

      var reset = el('button', 'dsn-btn dsn-btn--ghost dsn-btn--sm dsfr-reset', 'Neue Berechnung');
      reset.type = 'button';
      card.appendChild(reset);
      this.reset = reset;

      btn.addEventListener('click', function () { self.calculate(); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); self.calculate(); }
      });
      input.addEventListener('input', function () {
        input.classList.remove('dsn-invalid');
        errLine.style.display = 'none';
      });
      reset.addEventListener('click', function () {
        self.hideResult();
        input.value = '';
        input.focus();
      });

      this.appendChild(card);
    }

    hideResult() {
      this.result.classList.remove('dsfr-show');
      this.reset.classList.remove('dsfr-show');
    }

    showResult() {
      this.result.classList.add('dsfr-show');
      this.reset.classList.add('dsfr-show');
    }

    clearResult() {
      while (this.result.firstChild) this.result.removeChild(this.result.firstChild);
    }

    calculate() {
      var kg = parseFloat(String(this.input.value).replace(',', '.'));
      this.clearResult();

      if (!isFinite(kg) || kg < 0.5 || kg > 100) {
        this.input.classList.add('dsn-invalid');
        this.errLine.style.display = 'block';
        this.input.focus();
        this.hideResult();
        return;
      }

      var box = el('div', 'dsn-result dsn-step-in');

      if (this.alter === 'welpe' || this.alter === 'senior') {
        box.appendChild(el('p', 'dsn-text',
          this.alter === 'welpe' ? HINT_WELPE : HINT_SENIOR));
        this.result.appendChild(box);
        this.showResult();
        return;
      }

      var r = computeRation(kg, this.zustand);
      if (!r) { this.hideResult(); return; }

      box.appendChild(el('p', 'dsfr-amount', 'ca. ' + r.gramsPerDay + '\u00A0g pro Tag'));
      box.appendChild(el('p', 'dsfr-meals',
        'Aufgeteilt auf zwei Mahlzeiten: je ca. ' + r.gramsPerMeal + '\u00A0g.'));
      var pct = (r.factor * 100).toFixed(1).replace('.', ',').replace(',0', '');
      box.appendChild(el('p', 'dsfr-calc',
        'Rechenweg: ' + pct + '\u00A0% von ' + String(kg).replace('.', ',') + '\u00A0kg Körpergewicht, auf 5 g gerundet.'));
      box.appendChild(el('p', 'dsn-note', NOTE_STANDARD));

      var days = boxDays(this.boxGrams, r.gramsPerDay);
      var bridge = el('div', 'dsn-subcard');
      bridge.style.marginTop = '16px';
      bridge.appendChild(el('p', 'dsn-subcard-title', 'Zum Ausprobieren: ' + this.boxName));
      bridge.appendChild(el('p', 'dsn-text',
        'Fünf Sorten mit Innereien, zusammen 2 kg, roh und schockgefrostet.' +
        (days ? ' Bei deiner Tagesration reicht die Box etwa ' + days + ' Tage.' : '')));
      var link = el('a', 'dsn-cta', this.boxName + ' ansehen');
      link.href = this.boxUrl + (this.boxUrl.indexOf('?') === -1 ? '?' : '&') + 'utm_source=ai-bridge';
      link.setAttribute('data-event', 'ai_bridge_click_futtermenge_rechner_kennenlern-box');
      var arrow = el('span', '');
      arrow.innerHTML = ARROW_SVG;
      arrow.setAttribute('aria-hidden', 'true');
      link.appendChild(arrow);
      bridge.appendChild(link);
      box.appendChild(bridge);

      this.result.appendChild(box);
      this.showResult();
    }
  }

  customElements.define('ds-futter-rechner', DsFutterRechner);
})();
